import { Radio } from "@website/ui/radio";
import { useRadioGroup } from "@website/ui/radio-group/radio-group.hook";
import styles from "@website/ui/radio-group/radio-group.module.scss";
import {
  RadioGroupItemsWrapperType,
  RadioGroupPropertiesType
} from "@website/ui/radio-group/radio-group.types";
import { SizeType } from "@website/ui/types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const RadioGroup: FC<RadioGroupPropertiesType> = (properties) => {
  const { rootProps, radioProps } = useRadioGroup(properties);
  const {
    className,
    itemClassName,
    radioClassName,
    items,
    size,
    title,
    vertical,
    titleStyle,
    error,
    helperText,
    wrapItems = false
  } = properties;

  return (
    <div
      {...rootProps}
      className={`flex items-center ${wrapItems ? "flex-wrap !gap-0" : ""} ${
        vertical ? "flex-col" : "flex-row gap-5"
      } ${className ?? ""} ${styles["radio-group"]} ${
        error ? styles["error"] : ""
      }`}
      data-error={error}
    >
      {title ? (
        <p
          className={`${styles["title"]} ${titleStyle} ${
            size === SizeType.lg
              ? "text-xl"
              : size === SizeType.sm
                ? "text-base"
                : "text-lg"
          }`}
        >
          {title}
        </p>
      ) : null}
      <ItemsWrapper wrapItems={wrapItems}>
        {items.map((item, index) => (
          <Radio
            className={radioClassName}
            key={String(item.label)}
            labelClassName={itemClassName ?? itemClassName}
            {...radioProps[index]}
          />
        ))}
      </ItemsWrapper>
      {helperText ? (
        <div className={styles["helper-text"]}>{helperText}</div>
      ) : null}
    </div>
  );
};

const ItemsWrapper: FC<RadioGroupItemsWrapperType> = ({
  wrapItems,
  children
}) => {
  if (!wrapItems) return children;
  return <div className="flex items-center justify-start">{children}</div>;
};

const RadioGroupMemoized = memo(RadioGroup, deepCompare);
export { RadioGroupMemoized as RadioGroup };
